import { useContext } from 'react'

import IntegrationPartnerContent from '../integrationPartnerContext'


export default function useIntegrationPartnerPlan() {
  return useContext(IntegrationPartnerContent)
}

